module.exports = __webpack_public_path__ + "img/ADA-alt.8e22c8f2.svg";